/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAppointmentSlotData } from './genericApiResponseAppointmentSlotData';
import type { GenericApiResponseAppointmentSlotMessage } from './genericApiResponseAppointmentSlotMessage';
import type { GenericApiResponseAppointmentSlotPagination } from './genericApiResponseAppointmentSlotPagination';
import type { GenericApiResponseAppointmentSlotError } from './genericApiResponseAppointmentSlotError';

export interface GenericApiResponseAppointmentSlot {
  data?: GenericApiResponseAppointmentSlotData;
  message?: GenericApiResponseAppointmentSlotMessage;
  pagination?: GenericApiResponseAppointmentSlotPagination;
  error?: GenericApiResponseAppointmentSlotError;
  statusCode?: number;
}
